export default __webpack_public_path__ + "static/media/icon-event.874c8d85.svg";